import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';

import ApiService from 'services/ApiService/ApiService';
import { convertTokensToDollars } from 'utils/helpers';

import { STUDIO_REVENUE_INSIGHTS } from './Api';


const CHANGE_ORDER = 'cam4/earnings/CHANGE_ORDER';
const CHANGE_ORDER_BY = 'cam4/earnings/CHANGE_ORDER_BY';
const CHANGE_PAGE = 'cam4/earnings/CHANGE_PAGE';
const CHANGE_ROWS_PER_PAGE = 'cam4/earnings/CHANGE_ROWS_PER_PAGE';
const GET_EARNINGS = 'cam4/earnings/GET_EARNINGS';

const initialState = Immutable.fromJS({
  data: [],
  selected: [],
  numSelected: 0,
  page: 0,
  order: 'asc',
  orderBy: 'calories',
  rowsPerPage: 10,
  valueSelected: 0,
  options: [],
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_EARNINGS:
      return state.set('data', action.earnings);

    case CHANGE_PAGE:
      return state.set('page', action.page);

    case CHANGE_ROWS_PER_PAGE:
      return state.set('rowsPerPage', action.rowsPerPage);

    case CHANGE_ORDER:
      return state.set('order', action.order);

    case CHANGE_ORDER_BY:
      return state.set('orderBy', action.orderBy);

    default:
      return state;
  }
}

export const NAME = 'earnings';

const earnings = (state) => state[NAME];

const data = (state) => state[NAME].get('data');
const selected = (state) => state[NAME].get('selected');
const numSelected = (state) => state[NAME].get('numSelected');
const order = (state) => state[NAME].get('order');
const page = (state) => state[NAME].get('page');
const orderBy = (state) => state[NAME].get('orderBy');
const rowsPerPage = (state) => state[NAME].get('rowsPerPage');
const options = (state) => state[NAME].get('options');
const valueSelected = (state) => state[NAME].get('valueSelected');

export const selector = createStructuredSelector({
  earnings,
  data,
  selected,
  numSelected,
  order,
  orderBy,
  rowsPerPage,
  page,
  options,
  valueSelected,
});

function changePage(event, page) {
  return {
    type: CHANGE_PAGE,
    page,
  };
}

function changeRowsPerPage(rowsPerPage) {
  return {
    type: CHANGE_ROWS_PER_PAGE,
    rowsPerPage,
  };
}

function changeOrder(order) {
  return {
    type: CHANGE_ORDER,
    order,
  };
}

function changeOrderBy(orderBy) {
  return {
    type: CHANGE_ORDER_BY,
    orderBy,
  };
}

function updatePerformerEarnings(data) {
  return {
    type: GET_EARNINGS,
    earnings: data,
  };
}

function parseStudioRevenueResults(res) {
  const data = [];
  let counter = 0;

  res.data?.forEach?.((n) => {
    data[counter] = n;
    data[counter].amount = convertTokensToDollars(n.amount);
    data[counter].id = counter;
    data[counter].key = counter;
    data[counter].amountPerHour = convertTokensToDollars(
      data[counter].hours ? (data[counter].amount / data[counter].hours).toFixed(2) : 0
    );
    data[counter].link = '#';
    counter += 1;
  });


  return (dispatch) => {
    dispatch(updatePerformerEarnings(data));
  };
}

function getPerformerEarnings(user, date) {
  const url = ApiService.substitute(
    STUDIO_REVENUE_INSIGHTS,
    {
      username: user,
      startDate: date[0],
      endDate: date[1],
    }
  );

  return (dispatch) => ApiService.get(url).then((res) => dispatch(parseStudioRevenueResults(res)));
}

export const actionCreators = {
  getPerformerEarnings,
  updatePerformerEarnings,
  changePage,
  changeRowsPerPage,
  changeOrder,
  changeOrderBy,
};
